// src/constants/sideBarMenu.ts (or wherever this lives)
import {
  appointments,
  home,
  meet,
  patient,
  appointmentWhite,
  homeWhite,
  meetWhite,
  patientWhite,
  treat, // ✅
  treatWhite, // ✅
} from "../assets";

export const sideBarMenu = [
  { title: "Home", icon: home, activeIcon: homeWhite, path: "/doctor" },
  {
    title: "Appointments",
    icon: appointments,
    activeIcon: appointmentWhite,
    path: "/appointments",
  },
  {
    title: "Patients",
    icon: patient,
    activeIcon: patientWhite,
    path: "/patients",
  },
  { title: "Meet", icon: meet, activeIcon: meetWhite, path: "/meet" },

  // ✅ New
  {
    title: "Admissions",
    icon: treat,
    activeIcon: treatWhite,
    path: "/admissions",
    requiredPermission: "canAdmitPatient",
  },
];
